import $ from 'jquery';
import React, { PropTypes } from 'react';
import * as ProductApi from 'saas/products/api';
import ReactDOM from 'react-dom';
import Dropdown from 'common/components/Dropdown';
import { error } from 'plugins/toastr';
import { displayEditionModal } from 'saas/products/modals';

export const products = ctx => {
  const intervention = ctx.params.id;

  bindAssociate(intervention);
  bindCreate(intervention);
};

function bindCreate(intervention) {
  $('.bt-create-product').on('click', evt => {
    const $row = $(evt.target).closest('tr');
    const product = $row.attr('data-product');

    displayEditionModal(evt, product, _ => window.location.reload(true));
  });
}

function bindAssociate(intervention) {
  $('.bt-associate-product').on('click', evt => {
    const $button = $(evt.target);
    const $row = $button.closest('tr');

    const pointTask = $row.attr('data-point-task');
    const markerTask = $row.attr('data-marker-task');
    const workType = $row.data('work-type');
    const isComplementary = $row.data('complementary');
    const fromProduct = $row.attr('data-product');

    $button.addClass('loading');

    // Loading external products
    ProductApi.getAllExternalProducts(workType, !!isComplementary).then(
      products => {
        $button.removeClass('loading');

        console.log(products);

        const $modalRoot = document.getElementById('associate-modal');

        // Display associate modal
        ReactDOM.render(<AssociateModal products={products} />, $modalRoot);

        const $modal = $('#associate-product-modal');

        // Handling confirmation
        $modal
          .modal({
            onShow: () => {
              const $submitButton = $modal.find('button.approve');
              $submitButton.addClass('disabled');

              $modal.find('.dropdown').dropdown({
                onChange: () => $submitButton.removeClass('disabled'),
              });
            },
            onApprove: element => {
              const $element = $(element);
              $element.addClass('loading');

              const toProduct = $modal.find('.dropdown input').val();

              ProductApi.linkProduct(
                intervention,
                pointTask,
                markerTask,
                fromProduct,
                toProduct
              ).then(
                _ => window.location.reload(true),
                err => {
                  console.log('Error attempting to save product', err);

                  $element.removeClass('loading');
                  error(
                    "Une erreur est survenue pendant l'association du produit"
                  );
                }
              );

              return false;
            },
          })
          .modal('show');
      }
    );
  });
}

const renderDefaultProduct = () => (
  <div className="default text">Liste des produits tiers</div>
);

const renderProduct = product => (
  <div key={product.id} className="item" data-value={product.id}>
    {product.name}
  </div>
);

const AssociateModal = ({ products }) => (
  <div id="associate-product-modal" className="ui small modal">
    <div className="header">Associer un produit</div>
    <div className="content form">
      <div className="field">
        <label>Produits tiers</label>
        <Dropdown
          className="fluid"
          name="product"
          items={products}
          renderDefault={renderDefaultProduct}
          renderItem={renderProduct}
        />
      </div>
    </div>
    <div className="actions">
      <button className="ui primary approve labeled icon button">
        <i className="linkify icon" />
        Associer
      </button>
    </div>
  </div>
);

AssociateModal.propTypes = {
  products: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/errors/index.js